import { Delete, Edit } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Typography } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Button from "@mui/material/Button";
import { useEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import { DeleteFaq } from "../../../../actions/machines";
import { canUserPerformAction } from "../../../../shared-functions/userrights";
import { Theme247 } from "../../../../styles/Theme247";
import { ApplyStyle as _s } from "../../../../utils/ApplyStyle";
import NotificationAttachments from "../../../NotificationDetailsPage/NotificationAttachments";

// import {ReactComponent as DeleteSVG} from "../../../../assets/delete.svg"
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import { ReactComponent as EditSVG } from "../../../../assets/edit.svg";

import clsx from "clsx";
import CreateWorkflowStep from "../../../WorkFlowSteps/CreateWorkflowStep";
import { withCurrentAccountPrefix } from "../../../../utils/accountMode";

export default connect(
  ({ i18n, machines, profile }) => ({ i18n, machines, profile }),
  { DeleteFaq }
)((props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [expandedKey, setExpandedKey] = useState(false);

  const [accordianArray, setAccordianArray] = useState([]);
  const [showIframe, setShowIframe] = useState(-1);

  /*
   * Styles
   */
  const useStyles = makeStyles()(() => ({
    documentationContainer: {
      padding: "28px 24px",

      "& .CardButton": {
        marginRight: 24,
      },
    },
    sectionHeadlineSub: {
      marginTop: 20,
      marginBottom: 20,
    },
    cardclass: {
      border: 0,
    },
  }));
  const { classes } = useStyles();
  const i18n = props.i18n;
  const store = useStore().getState();
  const [navigate, setNavigate] = useState(false);
  const handleDelete = (questionanswernodeid) => {
    props.DeleteFaq({ nodeid: questionanswernodeid });
    setTimeout(() => {
      setNavigate(true);
    }, 1000);
  };

  // const handleChange = (expanded, key) => {
  //     setIsExpanded(expanded);
  //     setExpandedKey(key);
  //     let array = accordianArray;
  //     if (array[key]) {
  //         array[key].expanded = expanded
  //     }
  //     else {
  //         array.push({ key: key, expanded: expanded })
  //     }
  //     setAccordianArray(array)
  // }

  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const nodeid = params.get("nodeid");

  const navigatee = useNavigate();

  
  useEffect(() => {
    if (navigate) {
      if (nodeid) {
        navigatee(
          withCurrentAccountPrefix(
            "/machine-overview?nodeid=" +
              encodeURIComponent(nodeid ? nodeid : location.state?.nodeid) +
              "&tab=-1"
          )
        );
        setTimeout(() => {
          navigatee(
            withCurrentAccountPrefix(
              "/machine-overview?nodeid=" +
                encodeURIComponent(nodeid ? nodeid : location.state?.nodeid) +
                "&tab=3"
            )
          );
        }, 1000);
      } else {
        navigatee(
          withCurrentAccountPrefix(
            "/machine-overview?nodeid=" +
              encodeURIComponent(nodeid ? nodeid : location.state?.nodeid) +
              "&tab=3"
          )
        );
      }
    }
  }, [navigate]);


  return (
    <>
      <div className={classes.documentationContainer}>
        <div
          className={_s(Theme247.sectionHeader)}
          style={{ marginBottom: "10px" }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>
              <Typography variant="h1">{i18n?.users?.faqTitle}</Typography>
            </div>
            <div>
              {canUserPerformAction(
                props.profile?.features?.["equipment.faq"],
                "create"
              ) && (
                <Link
                  to="/create-faq"
                  state={{
                    from: "faq",
                    pageType: "add",
                    specifier: "internalfaq",
                    equipmentnodeid: props.machines?.equipment?.nodeid,
                  }}
                >
                  <Button
                    startIcon={<AddIcon />}
                    variant="contained"
                    color="primary"
                  >
                    {i18n.add_new_faq}
                  </Button>
                </Link>
              )}
            </div>
          </div>
        </div>

        <div className="MO_maintenance_desc">
          {i18n?.users?.machine_faq_description}
        </div>
        {/*  <Typography variant="h2" className={classes.sectionHeadlineSub}>{i18n.manufacturer_faqs}</Typography>
                {props.machines?.equipment?.hasquestionanswer==undefined? <p style={{marginLeft:25}}>Keine Hersteller FAQ</p>:''}
                {props.machines?.equipment?.hasquestionanswer && props.machines?.equipment?.hasquestionanswer.map((x, k) => {

                    if (x.questionanswer.specifier == 'manufacturerfaq') {
                        return (

                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography className={classes.heading} style={{ marginLeft: 7,fontWeight:'bold' }}>{x?.questionanswer?.question}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <>{x?.questionanswer?.answer}</>
                                        <NotificationAttachments edit={false} questionanswerAttachments={x?.questionanswer?.hasattachment} />
                                    </Typography>
                                </AccordionDetails>
                                <Link to={{
                                    pathname: '/edit-faq',
                                    state: {
                                        questionanswerAttachments: x?.questionanswer?.hasattachment,
                                        question: x?.questionanswer?.question,
                                        answer: x?.questionanswer?.answer,
                                        pageType: 'edit',
                                        specifier: 'manufacturerfaq',
                                        equipmentnodeid: props.machines.equipment.nodeid,
                                        from: 'faq',
                                        questionanswernodeid: x?.questionanswer?.nodeid
                                    }
                                }}>
                                    <div style={{ border: '1px solid rgba(0,0,0,0.12)', borderRadius: 4, marginLeft: 15, marginBottom: 10, height: 36, width: 151 }}>
                                        <Button size="large" style={{ marginTop: -3, marginLeft: 21 }} >
                                            {i18n.update_faq}
                                        </Button>
                                    </div>
                                </Link>
                            </Accordion>)
                    }
                })}
                {/* <div style={{ border: 0 }} >
                    <Link to={{ pathname: 'create-faq', state: { from: 'faq', pageType: 'add', specifier: 'manufacturerfaq', equipmentnodeid: props?.machines?.equipment?.nodeid } }}>
                        <CardButton title={i18n.add_new_faq} border='0px' icon={<AddIcon />} iconcolor="disabled" size="small" />
                    </Link>
                </div> 

                <Divider /> 

                <Typography variant="h2" className={classes.sectionHeadlineSub}>{i18n.internal_faqs}</Typography>*/}
        {props.machines?.equipment?.hasquestionanswer &&
          props.machines?.equipment?.hasquestionanswer.map((x, k) => {
            if (x?.questionanswer?.specifier == "internalfaq") {
              return (
                <div className="faqAccordian" key={k}>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      sx={{ padding: 0 }}
                      className="accSummary"
                    >
                      <Typography
                        component={"span"}
                        className={clsx(classes.heading, " title ")}
                        style={{ marginLeft: 0, fontFamily: "Roboto" }}
                      >
                        {x?.questionanswer?.question}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ padding: "8px 16px 16px 0px" }}>
                      {showIframe === k ? (  
                        <CreateWorkflowStep
                          propLocation={{
                            question:
                              x?.questionanswer?.question,
                            answer: x?.questionanswer?.answer,
                            pageType: "edit",
                            specifier: "internalfaq",
                            equipmentnodeid: props.machines.equipment.nodeid,
                            from: "faq",
                            questionanswernodeid: x?.questionanswer?.nodeid,
                            rootNodeId:props.machines?.equipment?.nodeid,
                            questionanswerAttachments: x?.questionanswer?.hasattachment,
                          }}
                        //   setShowIframe={setShowIframe}
                        />
                      ) : (
                        <Typography component={"span"}>
                          <div style={{ whiteSpace: "pre-wrap" }}>{x?.questionanswer?.answer}</div>
                          <NotificationAttachments
                            edit={false}
                            customFileChange={false}
                            questionanswerAttachments={
                              x?.questionanswer?.hasattachment
                            }
                            
                            rootNodeId={props.machines?.equipment?.nodeid}
                          />
                        </Typography>
                      )}

                      <div style={{ display: "flex", marginTop: "15px" }}>
                        <div>
                          {canUserPerformAction(
                            props.profile?.features?.["equipment.faq"],
                            "update"
                          ) && (
                            <div
                              onClick={() => {
                                setShowIframe(k);
                              }}
                            >
                              <Button
                                size="large"
                                variant="outlined"
                                startIcon={<EditSVG />}
                                style={{
                                  marginBottom: 21,
                                  border: "1px solid #0000001F",
                                  height: "36px",
                                  fontSize: "14px",
                                }}
                              >
                                {i18n.update_faq}
                              </Button>
                            </div>
                          )}
                        </div>
                        <div>
                          <Button
                            key={k}
                            size="large"
                            variant="outlined"
                            onClick={() => {
                              handleDelete(x?.questionanswer?.nodeid);
                            }}
                            startIcon={<DeleteForeverOutlinedIcon />}
                            style={{
                              marginLeft: 21,
                              color: "red",
                              border: "1px solid #0000001F",
                              height: "36px",
                              fontSize: "14px",
                            }}
                          >
                            {i18n.delete}
                          </Button>
                        </div>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </div>
              );
            }
          })}
        {/* {canUserPerformAction(props.profile?.features?.["equipment.faq"], "create") &&
                    <div style={{ border: 0 }} >
                        <Link to='/create-faq' state={{ from: 'faq', pageType: 'add', specifier: 'internalfaq', equipmentnodeid: props.machines?.equipment?.nodeid }}>
                            <CardButton title={i18n.add_new_faq} border='0px' icon={<AddIcon />} iconcolor="disabled" size="small" />
                        </Link>
                    </div>} */}
      </div>
    </>
  );
});
